/**
 * Radix `Slider` in controlled mode may call `onValueChange` after each `value` prop update. If we
 * always pass a fresh `[n]` tuple, React treats state as changed, Radix fires again, and Jest/jsdom
 * can spin forever. Reuse the previous tuple when the degree is unchanged.
 */
export function rotationSliderTupleIfUnchanged(prev: number[], nextDeg: number): number[] {
  return prev.length === 1 && prev[0] === nextDeg ? prev : [nextDeg]
}

export function thicknessSliderTupleIfUnchanged(prev: number[], next: number): number[] {
  return prev.length === 1 && Math.abs((prev[0] ?? 0) - next) < 1e-6 ? prev : [next]
}
